import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_have_emergency_alarm_system_types_emergencies_1'

export const dataPointDefinition = {
  retracedId: 'does_facility_have_emergency_alarm_system_types_emergencies_1',
  name: 'Does the facility have an emergency alarm system (for all types of emergencies other than fire) in line with legal requi',
  description:
    'This question covers legal requirements for alarms in emergency situations other than fire. This question covers legal requirements addressing the presence and functioning of alarms in emergency situations other than fire.',
  meta: {
    slcpMeta: {
      key: 'hs-eme-2',
      number: 'HS-EME-5',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-eme-2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30670,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
